import { ClientsSources, OrganizationTypes, ResponseStatuses } from '@/enums';
import {
  ApiPagination, TableFilterItem, RequestPagination, SelectItem, SimpleEnumType,
} from '@/types';
import { ClientContacts } from '@/modules/client-contacts/types';

export namespace Clients {
  export enum Pages {
    CLIENTS = 'clients',
    CLIENT_DETAIL = 'client',
    CLIENT_EDIT = 'client-edit',
  }

  export enum ClientStatuses {
    ACTIVE = 'Активен',
    DEACTIVE = 'Деактивирован',
  }

  export interface ClientStoreRequest {
    organization_type: OrganizationTypes,
    client_source_type: ClientsSources | null,
    name_client_company: string,
    name_client_organization: string,
    inn_client: string,
    kpp_client: string,
    city: string,
    region: string,
    address: string,
    is_resident: boolean,
    client_contact: ClientContacts.ClientContactRequest
  }

  export interface Client {
    [key: string]: unknown,
    id?: string | number;
    name_client_company: string, // Название компании клиента
    name_client_organization: string, // Название организации клиента (к которой он прикреплен)
    inn_client: string,
    kpp_client: string,
    city: string | SelectItem,
    region: string | SelectItem,
    address: string,
    organization_type: SimpleEnumType<OrganizationTypes> | OrganizationTypes | null,
    client_source_type: SimpleEnumType<ClientsSources> | ClientsSources | null,
    created_at?: string,
    is_resident: boolean,
    is_active?: boolean,
    client_contacts?: ClientContacts.ClientContact[]
  }

  export interface ClientListItem {
    id: number,
    company_name: string,
    inn: string,
    kpp: string,
    city: string,
    region: string,
    address: string,
    organization_type: string | null,
    is_active: boolean,
    contact: ClientContacts.TableItem | null,
  }

  export interface Filters {
    cities: string[],
    organization_types: TableFilterItem[],
  }

  export interface RequestFilters {
    search: string | null,
    city: string | null,
    organization_types: number[] | null,
    is_active: boolean,
  }

  export interface Response extends ApiPagination {
    data: {
      items: ClientListItem[],
      filters: Filters
    }
  }

  export type AddClientResponse = {
    code: ResponseStatuses.Fail | ResponseStatuses.Success;
    data?: {
      client_id?: string;
      is_active?: boolean;
    };
  };

  export interface ClientToAddItem {
    id: number,
    company_name: string,
    organization_name: string,
    inn: string | null,
    kpp: string | null,
    region: string | null,
    city: string | null,
    contact: ClientContacts.TableItem
  }

  export type ClientsToAddRequestFilters = {
    search: string
  }

  export type ClientsToAddRequest = {
    filters: ClientsToAddRequestFilters,
    pagination: RequestPagination,
  }

  export interface ClientsToAddResponse extends ApiPagination {
    data: {
      items: ClientToAddItem[]
    }
  }
}
